import View from '@/components/common/view'
import Index from '../components/truckEmployer/Index';// 主页
import PersonIndex from '../components/truckEmployer/person/Index';// 按人投保详情
import CarIndex from '../components/truckEmployer/car/Index';// 按车投保详情
import Fillin from '../components/truckEmployer/Fillin';// 按人投保填写页面
import Confirm from '../components/truckEmployer/Confirm';// 按人投保确认页面
import EditPerson from '../components/truckEmployer/person/Edit';// 按人投保编辑
import EditCar from '../components/truckEmployer/car/Edit';// 按车投保编辑
import EditRecord from '../components/truckEmployer/EditRecord';// 批改记录

export default [
	{
		path:'',
		component:Index
	},
	{
		path:'person',
		component:PersonIndex,
	},
	{
		path:'car',
		component:View,
		children:[
			{
				path:'',
				component:CarIndex
			},
		]
	},
	{
		path:'fillin/:type/:id?',
		component:Fillin
	},
	{
		path:'confirm/:type/:id',
		component:Confirm
	},
	{
		path:'edit/person/:id?',
		component:EditPerson
	},
	{
		path:'edit/car/:id?',
		component:EditCar
	},
	{
		path:'edit-record/:type/:id?',
		component:EditRecord
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/truckEmployer.js